
// Dados de exemplo para os relatórios financeiros

export const dadosReceitas = [
  { mes: "Jan", valor: 12000 },
  { mes: "Fev", valor: 15000 },
  { mes: "Mar", valor: 18000 },
  { mes: "Abr", valor: 14000 },
  { mes: "Mai", valor: 16000 },
  { mes: "Jun", valor: 17000 },
];

export const dadosDespesas = [
  { mes: "Jan", valor: 10000 },
  { mes: "Fev", valor: 11000 },
  { mes: "Mar", valor: 12000 },
  { mes: "Abr", valor: 13000 },
  { mes: "Mai", valor: 12500 },
  { mes: "Jun", valor: 13500 },
];

export const dadosReceitasDespesas = [
  { mes: "Jan", receitas: 12000, despesas: 10000 },
  { mes: "Fev", receitas: 15000, despesas: 11000 },
  { mes: "Mar", receitas: 18000, despesas: 12000 },
  { mes: "Abr", receitas: 14000, despesas: 13000 },
  { mes: "Mai", receitas: 16000, despesas: 12500 },
  { mes: "Jun", receitas: 17000, despesas: 13500 },
];
